<app-steps-summary [bookingFlowInfo]="bookingFlowInfo" class="container-narrow"></app-steps-summary>
